// extracted by mini-css-extract-plugin
module.exports = {"main":"input_main__DaJwu"};